<template>
  <div class="fullWidth">
    <ToggleServiceProduct @type-changed="selectType" />
    <div v-if="isProductShow" class="activeClient">
		<v-container class="grey lighten-5">
			<v-row no-gutters>
				<v-col lg="3" md="3" sm="4" xs="12">
					<v-sheet class="pa-2 chooseRegionTitle">{{ $t('prodCatSelect') }}</v-sheet>
					<v-combobox 
						v-model="searchCategory"
						:items="categoriesArray"
            @change="filterByCategories"
						multiple
						chips
					>
					</v-combobox>
				</v-col>
				<v-col lg="9" md="9" sm="8" xs="12">
					<v-card class="pa-2" outlined tile>
					<div>
						<section>
						<div class="container">
							<div>
							<SearchFilter ref="searchProdDetails" v-if="!(isSearchResult === false && marketPlace.products.length === 0)" />
							<div v-if="isSearchResult === true && marketPlace.products.length === 0">
								{{ $t('noSearchResult') }}
							</div>						
							</div>
							<div class="column">
							<MarketPlaceProductCard
								v-for="product of marketPlace.products"
								:key="product.product_id"
								:product="product"
								:clientId="inquireDetails.id"
								:parentProductIds="parentProductIds"
								@open-product-inquiry-form="openProductInquiryForm"
								@open-product-purchase-form="openProductPurchaseForm"
							/>                      
							</div>
						</div>
						</section>
					</div>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
      <b-modal id="product-inquiry-modal" hide-footer>
        <template v-slot:modal-title>
        <!-- {{ $t('productInquiryForm') }} -->
        </template>
        <ProductInquiryForm
          :productDetails="currentProduct"
          :clientDetails="clientDetails[0]"
          :inquireDetails="inquireDetails"
          @hide-product-inquiry-form="hideProductInquiryForm"
        />
      </b-modal>
      <b-modal id="product-purchase-modal" hide-footer>
        <template v-slot:modal-title>
        {{ $t('productPurchaseForm') }}
        </template>
        <ProductPurchaseForm
          :categoryNames="categoryNames"
          :productDetails="currentProduct"
          :inquireDetails="inquireDetails"
          :categoryExistence="categoryExistence"
          @hide-product-purchase-form="hideProductPurchaseForm"
        />
      </b-modal>
    </div>
    <div v-else>
		<v-container class="grey lighten-5" fluid>
			<v-row no-gutters>
				<v-col lg="3" md="3" sm="4" xs="12">
					<v-sheet class="pa-2 chooseRegionTitle">{{ $t('regionSelect') }}</v-sheet>
					<v-combobox 
						v-for="region of regions"
						:key="region"
						:id="region"
						v-model="selectedRegion[region]"
						:items="regionsRawData[region]"
						:label="region"
            @change="filterByRegions"
						multiple
						chips
					>
					</v-combobox>
				</v-col>			
				<v-col lg="9" md="9" sm="8" xs="12">
					<v-card class="pa-2" outlined tile>
					<div>
						<section>
						<div class="container">
							<div>
							<SearchFilter ref="searchExpDetails" v-if="!(isSearchResult === false && marketPlace.experiences.length === 0)" />
							<div v-if="isSearchResult === true && marketPlace.experiences.length === 0">
								{{ $t('noSearchResult') }}
							</div>						
							</div>
							<div class="column">
							<MarketPlaceExperienceCard
								v-for="experience of marketPlace.experiences"
								:key="experience.id"
								:experience="experience"
								:inquireDetails="inquireDetails"
								:parentExpIds="parentExpIds"
								@refresh-list="refreshExpList"
							/>                      
							</div>
						</div>
						</section>
					</div>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
    </div>
  </div>
</template>

<script>
import MarketPlaceProductCard from '@/components/ui/MarketPlaceProductCard.vue'
import MarketPlaceExperienceCard from '@/components/ui/MarketPlaceExperienceCard.vue'
import ProductInquiryForm from '@/components/forms/ProductInquiryForm.vue'
import ProductPurchaseForm from '@/components/forms/ProductPurchaseForm.vue'
import ToggleServiceProduct from '@/components/common/ToggleServiceProduct.vue'
import SearchFilter from '@/components/common/SearchFilter.vue'
import { mapState } from 'vuex'

export default {
  metaInfo() {
    return {
      title: this.$i18n.t('marketplace')
    }
  },
  components: {
    MarketPlaceProductCard,
    MarketPlaceExperienceCard,
  	ProductInquiryForm,
    ProductPurchaseForm,
    SearchFilter,
    ToggleServiceProduct
  },
  data() {
    return {
      isProductShow: true,
      loading: true,
      errored: false,
      errors: null,
      isSearchResult: false,
      inquireDetails: {},
      clientDetails: [],
      categoryNames: [],
      currentProduct: {},
      parentProductIds: {},
      parentExpIds: [],
      regions: [],
      selectedRegion: {},
      regionsRawData: {},
      categoriesArray: [],
      searchCategory: null,
      categoryExistence: {
        exist: false,
        suggestedName: null,
        categoryId: null
      }
    }
  },
  async created() {
    this.inquireDetails = JSON.parse(localStorage.getItem('user'));
    await Promise.all([
      this.$store.dispatch('productCategory/fetchProductCategories'),
      this.$store.dispatch('marketPlace/fetchMarketPlaceProducts'),
      this.$store.dispatch('marketPlace/fetchMarketPlaceExperiences')
    ])
    this.categoriesArray = this.marketPlace.products.map(product => product.category_name)
    this.categoriesArray = [...new Set(this.categoriesArray)]
    this.parentProductIds = await this.$store.dispatch('marketPlace/fetchPurchasedProductIds')
    this.parentExpIds = await this.$store.dispatch('marketPlace/fetchPurchasedExpIds')
    this.clientDetails = await this.$store.dispatch('client/fetchClient', this.inquireDetails.id)
		this.categoryNames = this.productCategory.productCategories
    this.regions = [...new Set(this.marketPlace.experiences.map((exp) => exp.region))]
    this.marketPlace.experiences.map((exp) => {
      if (!this.regionsRawData[exp.region]) {
        this.regionsRawData[exp.region] = []
        this.selectedRegion[exp.region] = []
      }
      this.regionsRawData[exp.region].push(exp.subregion)
    })
  },
  async mounted() {
    this.isSearchResult = false
  },
  methods: {
    selectType(value) {
      this.isProductShow = value
    },
    openProductInquiryForm(product) {
      this.$bvModal.show('product-inquiry-modal')
      this.currentProduct = product
    },
    hideProductInquiryForm() {
      alert(this.$t('inquirySent'))
      this.$bvModal.hide('product-inquiry-modal')
    },
    async openProductPurchaseForm(product) {
      this.$store.dispatch('client/profileCompleteness').then(async response => {
        if (response && response.profile_complete === true)  {
          if (!product.client_id) {
            this.$bvModal.show('product-purchase-modal')
            this.currentProduct = product
          } else {
            const response = await this.$store.dispatch(
              'marketPlace/checkCategoryExist',
                {
                  name: product.category_name,
                  tax_rate: product.category_tax_rate
                }
              )
            if (response.exist === false) {
              this.categoryExistence.exist = false
              if (response.suggestedName) this.categoryExistence.suggestedName = response.suggestedName
            } else {
              this.categoryExistence.exist = true
              this.categoryExistence.categoryId = response.categoryId
            }
            this.$bvModal.show('product-purchase-modal')
            this.currentProduct = product
          }
        } else {
          alert(this.$t('completeProfileFirst'))
        }
      })
    },
    async hideProductPurchaseForm() {
      this.parentProductIds = await this.$store.dispatch('marketPlace/fetchPurchasedProductIds')
      this.$bvModal.hide('product-purchase-modal')
    },
    async searchTerm() {
      if (this.isProductShow) await this.searchProducts()
      else await this.searchExperiences()
      this.isSearchResult = true
    },
    async clearSearch() {
      if (this.isProductShow) await this.searchProducts()
      else await this.searchExperiences()
      this.isSearchResult = false
    },
    async refreshExpList() {
      this.parentExpIds = await this.$store.dispatch('marketPlace/fetchPurchasedExpIds')
    },
    async filterByRegions() {
      await this.searchExperiences()
    },
    async searchExperiences() {
      const searchBody = {}
      searchBody.wordSearch = this.$refs.searchExpDetails.search.trim()
      Object.keys(this.selectedRegion).forEach((key) => this.selectedRegion[key].length == 0 && delete this.selectedRegion[key])
      if (Object.keys(this.selectedRegion).length > 0) searchBody.regionSearch = this.selectedRegion
      await this.$store.dispatch('marketPlace/searchExperiences', searchBody)
    },
    async filterByCategories() {
      await this.searchProducts()
    },
    async searchProducts() {
      const searchBody = {}
      if (this.$refs.searchProdDetails.search) searchBody.wordSearch = this.$refs.searchProdDetails.search.trim()
      if (this.searchCategory && this.searchCategory.length > 0) searchBody.categorySearch = this.searchCategory
      await this.$store.dispatch('marketPlace/searchProducts', searchBody)
    }
  },
  computed: mapState([
    'marketPlace',
    'productCategory'
  ])
}
</script>

<style lang="scss" scoped>
.fullWidth {
	width: 100%;
}

.active {
  background: var(--bg-light)!important;
  color: var(--bright) !important;
  border: none !important;
}
.fieldPrice {
  width: 30%;
}

.inp {
  border: none;
  border-bottom: 0.2px solid var(--bg);
  padding: 5px 10px;
  outline: none;
  margin-bottom: 1.2em;
  background-color: var(--grey-superlight);
}
.inp:hover {
  border-color: var(--primaryDark);
}

[placeholder]:focus::-webkit-input-placeholder {
  transition: text-indent 0.4s 0.4s ease;
  text-indent: -100%;
  opacity: 1;
}

[v-cloak] {
  display: none;
}

.unitProductsEmpty {
  display: none; //! none when FIRST unitProduct with this client_id is already found in db //
}

.chooseRegionTitle {
	text-transform:uppercase;
	font-weight: 600;
	letter-spacing: 1px;
	font-size: 1.1rem;
}
.btn {
  border: solid 1px var(--bg);
  color: var(--bg);
  font-weight: normal !important;
}

.errorMessage {
  margin-bottom: 0.2em;
  color: var(--primaryDark);
}

.product-cards {
  margin-top: 20px;
  margin-left: 0;
  padding-left: 0px;
}

.showOverall {
  border: none;
  color: var(--bright);
  background-color: var(--primaryDark) !important;
}

.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}

.leftText {
	text-align: left !important;
}

.trash-Icon {
  background: var(--bg-superLight);
  color: var(--bright);
  padding: 0.3em;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 235px;
  height: 35px;
  right: 0;
  position: relative;
  text-align: left; 
  cursor: pointer;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}

  .column {
    display: flex;
    flex-flow: wrap;
    height: 100%;
	justify-content: center;
  }

@media (max-width: 500px) {
  .column {
    display: inherit;
  }
}


// Breakpoints
$bp-maggie: 15em;
$bp-lisa: 30em;
$bp-bart: 48em;
$bp-marge: 62em;
$bp-homer: 90em;

a {
  color: var(--primaryDark);

  &:hover,
  &:focus {
    color: var(--primaryDark);
  }
}

.container {
	// margin-bottom: 2em;

  @media (min-width: $bp-bart) {
    // margin: 2%;
  }

  @media (min-width: $bp-homer) {
    // margin: 2em auto;
    // max-width: $bp-homer;
  }
}

@media screen and (max-width: 500px){
  .changeStockMobile {
  letter-spacing: 0;
  margin-left: 10px;
}
  .trash-Icon {
  width: 175px;
}
}

</style>

